import axios from "axios";
import AppConstant from "../assets/js/AppConstant";
import AppUserProfile, { UserType } from "../assets/js/AppUserProfile";

export const GetTicketList = async ({ bodyPayload }) => {
  try {
    const response = await axios.post(
      AppConstant.MAIN_URL + "/marketing-claim-api/v1/ticket/list",
      {
        ...bodyPayload,
        ...(AppUserProfile.getData().whoami === UserType.REVER && {
          is_only_assigned_to_me: true,
        }),
      }
    );
    return response;
  } catch (e) {
    void e;
  }
};

export const GetCarModelOptions = async () => {
  try {
    return await axios.get(
      AppConstant.MAIN_URL + "/marketing-claim-api/v1/option/list-car-model"
    );
  } catch (e) {
    void e;
  }
};

export const GetActivityOptions = async () => {
  try {
    return await axios.get(
      AppConstant.MAIN_URL + "/marketing-claim-api/v1/option/list-activity"
    );
  } catch (e) {
    void e;
  }
};

export const GetBudgetOptions = async () => {
  try {
    return await axios.get(
      AppConstant.MAIN_URL + "/marketing-claim-api/v1/option/list-budget"
    );
  } catch (e) {
    void e;
  }
};

export const CreateTicket = async ({ bodyPayload }) => {
  return await axios.post(
    AppConstant.MAIN_URL + "/marketing-claim-api/v1/ticket",
    bodyPayload
  );
};

export const GetApproverList = async ({ token }) => {
  try {
    return await axios.get(
      AppConstant.MAIN_URL + "/marketing-claim-api/v1/user/list",
      {
        headers: {
          "x-api-key": AppConstant.X_API_KEY,
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (e) {
    void e;
  }
};

export const UpdateProposalTicket = async ({ ticketId, bodyPayload }) => {
  return await axios.patch(
    AppConstant.MAIN_URL +
      `/marketing-claim-api/v1/ticket/${ticketId}/proposal-revise`,
    bodyPayload
  );
};

export const GetTicketById = async ({ ticketId }) => {
  try {
    return await axios({
      method: "get",
      url: `/marketing-claim-api/v1/ticket/${ticketId}`,
    });
  } catch (e) {
    void e;
  }
};

export const CancelAllTicket = async (ticketId) => {
  if (!ticketId) return;
  return await axios.patch(
    AppConstant.MAIN_URL + `/marketing-claim-api/v1/ticket/${ticketId}/cancel`
  );
};
